import React from 'react';

const Footer = () => {
    return (
        <div className="bg-dark text-white text-center  p-5">
            <h5 className="text-success bg-danger opacity-75 text-white">Food shown are for illustration purpose only. Actual product may differ from the images shown in this website. 
            <br/>
            The Valhalla name, logos, and related marks are trademarks of Vahalla, Inc.</h5>
            <h6 className="text-secondary opacity-50 mt-3"> © Copyright 2021 TripleN. by Nafish All Rights Reserved.</h6>
        </div>
    );
};

export default Footer;